var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizer12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 332,
    viewBox: "0 0 332 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-334 -347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 332,
    rx: 20,
    transform: "translate(666 679) rotate(180)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 679) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(550 679) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 679) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 447) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(550 447) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 447) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 563) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 563) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    transform: "translate(540 553) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizer12);
export default __webpack_public_path__ + "static/media/visualizer-12.1c4046de6d2843a847ea1dc2654cd6eb.svg";
export { ForwardRef as ReactComponent };